import React from "react";

export function FAQ() {
  return <iframe src="https://vitreus.io/presale-faq/" className={`w-full h-full`} />;
}
